"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DividerViews = void 0;
var DividerViews;
(function (DividerViews) {
    DividerViews["single"] = "single";
    DividerViews["double"] = "double";
})(DividerViews || (exports.DividerViews = DividerViews = {}));
